import config from "@/config/config";

import Index from "@/pages/platform/index.vue";
import List from "@/pages/platform/list/list.vue";
import View from "@/pages/platform/view/view.vue";
import New from "@/pages/platform/new/new.vue";
import Edit from "@/pages/platform/edit/edit.vue";

const modulePermission = config.modules.platform;

export default {
  path: "/platform",
  name: "platform",
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: "enabled_read",
  },
  children: [
    {
      path: "list",
      name: "platform-list",
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
    },
    {
      path: ":id",
      name: "platform-view",
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
      props: true,
    },
    {
      path: "new",
      name: "platform-new",
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_create",
      },
    },
    {
      path: ":id/e",
      name: "platform-edit",
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_edit",
      },
      props: true,
    },
  ],
};
